import { Control, Controller, FieldValues, Path } from "react-hook-form";
import {
	SearchableDropdownInput,
	type SearchableDropdownInputOption,
	type SearchableDropdownInputProps,
} from "../inputs/SearchableDropdownInput";

export type FormSearchableInputWithDropdownProps<
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
> = {
	buttonClassName?: string;
	buttonIconClassName?: string;
	optionsClassName?: string;
	optionClassName?: string;
	optionIconClassName?: string;
	placeholder?: string;
	compact?: boolean;
	disabled?: boolean;
	readonly?: boolean;
	options: SearchableDropdownInputOption[];
	disabledOptions?: string[];
	control: Control<TFieldValues, any, TTransformedValues>;
	name: Path<TFieldValues>;
	errorMessage?: string;
	anchor?: SearchableDropdownInputProps["anchor"];
};

export const FormSearchableInputWithDropdown = <
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
>({
	name,
	control,
	disabled,
	readonly,
	...props
}: FormSearchableInputWithDropdownProps<TFieldValues, TTransformedValues>) => {
	return (
		<Controller
			name={name}
			control={control}
			render={({ field: { ref, onBlur, ...field }, fieldState }) => {
				return (
					<SearchableDropdownInput
						{...props}
						{...field}
						disabled={disabled}
						readonly={readonly}
						error={fieldState.error}
					/>
				);
			}}
		/>
	);
};
